import styled from 'styled-components';
import { lightGray, gray, whitesmoke } from 'utils/style/colors';

interface IFieldChipProps {
  hasValue: boolean;
}

export const QuestionInfoWrapper = styled('div')`
  border-radius: 10px;
  border: 1px solid #c8cee0;
  display: flex;
  justify-content: center;
  margin: 0rem 0 0.5rem;
  min-height: 4rem;
`;

export const QuestionInfoTitle = styled('span')`
  background-color: ${gray};
  border-bottom-right-radius: 4px;
  border-left: 1px solid #c8cee0;
  min-height: 5rem;
  border-top-right-radius: 4px;
  color: #999;
  font-weight: 400;
  text-align: center;
  writing-mode: vertical-rl;
`;

export const QuestionInfoChildren = styled('div')`
  white-space: pre-wrap;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  margin: auto;
  padding: 0;
`;

export const FieldChipWrapper = styled('div')<IFieldChipProps>`
  align-items: stretch;
  color: #696969;
  display: inline-flex;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 2rem;
  margin: 3px;
  width: 100%;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  & > span {
    background-color: ${whitesmoke};
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: ${(props) => (props.hasValue ? 'unset' : '6px')};
    border-top-left-radius: ${(props) => (props.hasValue ? 'unset' : '6px')};
    border-top-right-radius: 6px;
    flex: 1;
    display: inline-flex;
    align-items: center;
    padding: 0 0.5rem;
    word-break: break-word;
    @media screen and (max-width: 768px) {
      justify-content: center;
      border-bottom-right-radius: ${(props) =>
        props.hasValue ? 'unset' : '6px'};
      border-bottom-left-radius: ${(props) =>
        props.hasValue ? 'unset' : '6px'};
      border-top-left-radius: 6px;
    }
  }
`;

export const FieldChipValue = styled('div')`
  align-items: center;
  width: 100%;
  background-color: ${lightGray};
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
  display: inline-flex;
  flex: 1;
  // justify-content: center;
  padding: 0 0.5rem;
  text-align: start;
  @media screen and (max-width: 768px) {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-top-left-radius: unset;
    border-top-right-radius: unset;
  }
`;
